import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom'
import RubricaScrollableRow from './RubricaScrollableRow'
import ScrollableButtons from '../ScrollableButtons'
import PrintButton from '../PrintButton'

class RubricaScrollable extends Component {
    constructor(props) {
        super(props);
        let currIndex = props.items.length > 0 ? 0 : -1;
        let rv = this.updateData(props.count, props.items, props.rowperpage, currIndex);
        this.state = {
            currIndex : rv.currIndex,
            pages: rv.pages,
            firstPage: 1,
            lastPage: rv.lastPage,
        };

        this.onChangePage = this.onChangePage.bind(this);
        this.onChangeItem = this.onChangeItem.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        let currIndex = nextProps.page !== this.props.page ? 0 :  this.state.currIndex;
        let rv = this.updateData(nextProps.count, nextProps.items, nextProps.rowperpage, currIndex, nextProps.showItem);
        this.setState(rv);
    }

    updateData(count, items, rowperpage, currIndex, showItem){
        let lastPage = Math.ceil(count / rowperpage);
        let pages = [];
        for (let i = 1; i <= lastPage; i++) {
            pages.push(i);
        }
        if (items.length <= 0)
        {
            currIndex = -1
        }
        else if (currIndex > items.length)
        {
            currIndex = 0
        }
        else if (currIndex === -1){
            currIndex = 0
        }

        if (showItem !== undefined && showItem !== null){
            let newIndex = items.findIndex((element, index, array) => {
                return element.idSoggetto === showItem.idSoggetto;
            })
            if (newIndex >= 0){
                currIndex = newIndex;
            }
        }
        return {pages, lastPage, currIndex}
    }

    onChangePage(newpage, cb) {
        switch (newpage)
        {
            case "P":
                if (this.props.page > this.state.firstPage){
                    this.props.onChangePage(this.props.page - 1);
                    if (cb !== undefined){ cb() }
                }
                break;
            case "N":
                if (this.props.page < this.state.lastPage){
                    this.props.onChangePage(this.props.page + 1);
                    if (cb !== undefined){ cb() }
                }
                break;
            default:
                if (this.props.page !== newpage){
                    this.props.onChangePage(newpage);
                    if (cb !== undefined){ cb() }
                }
                break;
        }
    }

    onChangeItem(newIndex) {
        switch (newIndex)
        {
            case "P":
                if (this.state.currIndex > 0){
                    this.setState({currIndex: this.state.currIndex - 1})
                }
                break;
            case "N":
                if (this.state.currIndex < this.props.items.length){
                    this.setState({currIndex: this.state.currIndex + 1})
                }
                break;
            default:
                break;
        }
    }

    onExportClick(ev){
        if (this.props.onExportRubrica !== undefined){
            this.props.onExportRubrica()
        }
    }

    render() {
        let btnNuovoSoggetto = null;
        if (this.props.readOnly == false){
                    btnNuovoSoggetto = (<Link to={`/app/rubrica/new`}>
                        <div className="ui left floated small primary labeled icon button">
                            <i className="plus icon"></i> Nuovo Soggetto
                        </div>
                    </Link>         );   
                }

        let item = this.state.currIndex >= 0 ? this.props.items[this.state.currIndex] : null;

        return (
            <div className="ui segments">
                <div className="ui secondary segment no-print">
                    <div className="ui three column stackable grid">
                        <div className="row">
                            <div className="column">
                                {btnNuovoSoggetto}
                                <PrintButton />
                            </div>
                            <div className="column">
                                <h4>Pagina {this.props.page} di {this.state.lastPage}. Soggetto n. {this.state.currIndex + 1} su {this.props.items.length} caricati.</h4>
                            </div>
                            <div className="column">
                                <ScrollableButtons
                                    itemCount={this.props.items.length}
                                    itemIndex={this.state.currIndex}
                                    onChangeItem={this.onChangeItem}
                                    pages={this.state.pages} page={this.props.page}
                                    firstPage={this.state.firstPage} lastPage={this.state.lastPage}
                                    onChangePage={this.onChangePage}
                                />
                            </div>
                        </div>
                    </div>

                </div>

                <div id="printme" className="ui segment">

                    {
                        this.props.senderList.every((sender, index, array) => {
                            return sender.soggetto.idSoggetto !== item.idSoggetto
                        }) ?
                            <RubricaScrollableRow item={item} key={item ? item.idSoggetto: 0} canAddSoggetto={true}  onAddSoggetto={this.props.onAddSoggetto} onDeleteSoggetto={this.props.onDeleteItem} readOnly={this.props.readOnly} />
                            :
                            <RubricaScrollableRow item={item} key={item ? item.idSoggetto : 0} canAddSoggetto={false}  onAddSoggetto={this.props.onAddSoggetto} onDeleteSoggetto={this.props.onDeleteItem} readOnly={this.props.readOnly}/>
                    }

                </div>

{/*
                <div id="printme" className="ui segment">



                    {this.props.items.map((item) => (

                        this.props.senderList.every((sender, index, array) => {
                            return sender.soggetto.idSoggetto !== item.idSoggetto
                        }) ?
                            <RubricaScrollableRow item={item} key={item.idSoggetto} canAddSoggetto={true}  onAddSoggetto={this.props.onAddSoggetto} onDeleteSoggetto={this.props.onDeleteItem} />
                            :
                            <RubricaScrollableRow item={item} key={item.idSoggetto} canAddSoggetto={false}  onAddSoggetto={this.props.onAddSoggetto} onDeleteSoggetto={this.props.onDeleteItem} />
                    ))}
                </div>
*/}
            </div>)
    }

}

RubricaScrollable.PropTypes = {
    items: PropTypes.array,
    senderList: PropTypes.array,
    count: PropTypes.number,
    page: PropTypes.number,
    rowperpage: PropTypes.number,
    tableOrderingField: PropTypes.string,
    tableOrderingDirection: PropTypes.oneOf(['A', 'D']),
    onChangePage: PropTypes.func,
    onChangeOrder: PropTypes.func,
    onAddSoggetto: PropTypes.func,
    onExportRubrica: PropTypes.func,
    onDeleteItem: PropTypes.func,
    showItem: PropTypes.object,
    readOnly: PropTypes.bool
}
export default RubricaScrollable;




/** WEBPACK FOOTER **
 ** ./src/components/rubrica/RubricaScrollable.js
 **/